import React, { Suspense, useMemo } from "react";
import { Canvas, useLoader } from "@react-three/fiber";
import { OrbitControls } from "@react-three/drei";
import { STLLoader } from "three-stdlib";
import * as THREE from "three";
import "../../../style/custommillingHubdashboard.css";

/* ---------- STL MODEL ---------- */
const STLModel = ({ url }: { url: string }) => {
  const geometry = useLoader(STLLoader, url);

  // ✅ Center & scale model safely
  const centeredGeometry = useMemo(() => {
    geometry.computeBoundingBox();
    geometry.center();
    geometry.computeVertexNormals();
    return geometry;
  }, [geometry]);

  return (
    <mesh geometry={centeredGeometry}>
      <meshStandardMaterial color="#4f46e5" metalness={0.3} roughness={0.6} />
    </mesh>
  );
};

/* ---------- MODAL ---------- */
interface Props {
  selectedStl: string | null;
  setShowStlModal: (value: boolean) => void;
}

const STLViewerModal: React.FC<Props> = ({
  selectedStl,
  setShowStlModal,
}) => {
  // ✅ prevent loader crash
  if (!selectedStl || !selectedStl.endsWith(".stl")) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{
        background: "rgba(0,0,0,0.6)",
        zIndex: 2000,
      }}
    >
      <div className="modal-dialog modal-md modal-dialog-centered">
        <div className="modal-content">

          {/* HEADER */}
          <div className="modal-header">
            <h5 className="modal-title">STL Viewer</h5>
           
             <button type="button"   onClick={() => setShowStlModal(false)} className="btn-close custom-close-btn" data-bs-dismiss="modal" aria-label="Close"><i className="bi bi-x customcross"></i></button>
         
          </div>

          {/* BODY */}
          <div className="modal-body stl-viewer-body p-0" style={{ height: "400px" }}>
            <Canvas
              camera={{ position: [0, 0, 150], fov: 45 }}
              onCreated={({ gl }) => {
                gl.setClearColor("#f8fafc");
              }}
              className="stl-canvas-section"
            >
              <ambientLight intensity={0.7} />
              <directionalLight position={[20, 20, 20]} intensity={1.2} />

              {/* ✅ Suspense prevents runtime crash */}
              <Suspense fallback={null}>
                <STLModel url={selectedStl} />
              </Suspense>

              <OrbitControls
                enablePan
                enableZoom
                enableRotate
                autoRotate={false}
              />
            </Canvas>
          </div>

        </div>
      </div>
    </div>
  );
};

export default STLViewerModal;
